import { Form, Modal, ModalProps } from 'antd';
import GroupsGeneralForm from '../GroupsGeneralForm';
import { useState } from 'react';
import { useCreateGroup } from '@/core/domain/operational/Groups/Groups.hooks';
import { GroupFormValues } from '@/core/domain/operational/Groups/Groups.types';
import { useDisclosure } from '@/hooks';
import CreateSubGroupModal from './CreateSubGroupModal';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  onCallback: (subGroupId: number) => void;
}

export default function CreateGroupWithSubGroupModal({ ...props }: Props) {
  const [subGroupCreateOpened, subGroupCreateActions] = useDisclosure();

  const [groupId, setGroupId] = useState<number>();

  const [form] = Form.useForm<GroupFormValues>();

  const createGroup = useCreateGroup();

  function handleCancel() {
    props.onCancel();

    form.resetFields();
  }

  async function handleOk() {
    const values = await form.validateFields();

    const response = await createGroup.mutateAsync({ ...values, active: true });

    setGroupId(response.id);

    handleCancel();

    subGroupCreateActions.open();
  }

  return (
    <>
      <Modal
        {...props}
        title="Criação do grupo"
        width={800}
        onOk={handleOk}
        okText="Criar"
        onCancel={handleCancel}
        confirmLoading={createGroup.isLoading}
      >
        <GroupsGeneralForm form={form} />
      </Modal>

      <CreateSubGroupModal
        groupId={groupId}
        open={subGroupCreateOpened}
        onCancel={subGroupCreateActions.close}
        onCallback={props.onCallback}
      />
    </>
  );
}
